export const UPDATE_INVESTMENT_ATTEMPT = 'UPDATE_INVESTMENT_ATTEMPT';
export type UPDATE_INVESTMENT_ATTEMPT = typeof UPDATE_INVESTMENT_ATTEMPT;

export const UPDATE_INVESTMENT_SUCCESS = 'UPDATE_INVESTMENT_SUCCESS';
export type UPDATE_INVESTMENT_SUCCESS = typeof UPDATE_INVESTMENT_SUCCESS;

export const UPDATE_INVESTMENT_FAILURE = 'UPDATE_INVESTMENT_FAILURE';
export type UPDATE_INVESTMENT_FAILURE = typeof UPDATE_INVESTMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investment/update/Types.tsx